<template>
    <div class="home_back_button">
        <div class="wrapper" :class="{hidden: is_hidden}">
            <!--PC用ホームボタン-->
            <div class="pc"><router-link to="/" class="homebtn"><img src="../assets/images/sukikamolist_homebtn.svg" alt="ホームボタン"></router-link></div>
            <!--戻るボタン-->
            <div class="back_btn" @click="$router.go(-1)"><img src="../assets/images/back_btn.svg" alt="戻るボタン"></div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Util from '../assets/js/Util'

    export default {
        name: "HomeBackButton",
        data: () => ({
            is_hidden: false,
            callback: () => {}
        }),
        computed: {
            ...mapState('search', ['search_conditions']),
        },
        mounted() {
            const app = document.getElementById('app');
            const target = this.$el.querySelector('.wrapper');
            this.callback = () => this.is_hidden = !Util.detectCollision(app, target);
            window.addEventListener('scroll', this.callback);
            this.callback();
        },
        destroyed() {
            window.removeEventListener('scroll', this.callback);
        },

        methods: {

        },
    }
</script>

<style scoped lang="scss">
    .home_back_button .wrapper{
        position: fixed;
        transition: 0.3s ease;
        left: 13%;
        @media screen and (max-width:1800px) {
            left: 10%;
        }
        @media screen and (max-width:1700px) {
            left: 7%;
        }
        @media screen and (max-width:1600px) {
            left: 4%;
        }
        z-index: 50;
        &.hidden{
            opacity: 0;
            visibility: hidden;
        }
    }

    /*ホームボタン、戻るボタン*/
    .homebtn {
        top: 100px;
    }
    .back_btn {
        top: 150px;
    }
    /*sp用-----------------------------------------------------------------------------------*/
    @media only screen and (max-width: 639px) {
        .home_back_button .wrapper{
            top: 120px;
            .back_btn {
                width: 10px;
                left: 10px;
                z-index: 10;
            }
        }
    }
</style>
